import { DefaultTheme } from 'styled-components'
import colors from 'core/theme/colors'

const stateOfJSThemeColors: DefaultTheme['colors'] = {
    background: colors.greyDarker,
    backgroundBackground: '#151618',
    backgroundForeground: colors.greyDarkish,
    backgroundAlt: colors.greyDarkish,
    backgroundAlt2: colors.greyDark,
    backgroundInverted: colors.greyLight,
    backgroundInvertedAlt: '#FBFAE1',
    text: colors.greyLight,
    textAlt: colors.greyMedium,
    textInverted: colors.greyDarker,
    textHighlight: colors.teal,
    link: colors.teal,
    linkActive: colors.tealLighter,
    contrast: colors.red,
    border: colors.greyMediumest,
    heatmap: colors.teal,
    lineChartDefaultColor: colors.red,
    barChart: {
        primary: colors.red,
        secondary: colors.redDarker,
    },
    ranges: {
        tools: {
            would_use: colors.teal,
            would_not_use: colors.red,
            interested: colors.tealLight,
            not_interested: colors.redLight,
            never_heard: colors.greyMedium,
        },
        toolSections: {
            javascript_flavors: colors.indigo,
            front_end_frameworks: colors.pink,
            datalayer: colors.red,
            back_end_frameworks: colors.purple,
            testing: colors.orange,
            build_tools: colors.yellow,
            mobile_desktop: colors.green,
            other_tools: colors.blue,
        },
        features: {
            used: colors.teal,
            heard: colors.tealDarker,
            never_heard: colors.greyMedium,
        },
        featureSections: {
            syntax: colors.indigo,
            language: colors.pink,
            data_structures: colors.red,
            browser_apis: colors.purple,
            other_features: colors.orange,
        },
        features_simplified: {
            know_it: colors.tealDarker,
            used_it: colors.teal,
        },
        gender: {
            male: colors.blue,
            female: colors.teal,
            non_binary: colors.red,
            prefer_not_to_say: colors.greyMediumer,
        },
        opinions: {
            0: colors.red,
            1: colors.redLight,
            2: colors.greyMedium,
            3: colors.tealLight,
            4: colors.teal,
        },
    },
    distinct: [
        colors.indigo,
        colors.teal,
        colors.pink,
        colors.red,
        colors.green,
        colors.yellow,
        colors.aqua,
        colors.orange,
        colors.olive,
        colors.skyblue,
        colors.purple,
    ],
    countries: [
        colors.teal,
        colors.tealLight,
        colors.tealLighter,
        colors.redLighter,
        colors.red,
        colors.redDark,
        colors.redDarker,
    ],
    velocity: [
        colors.tealDarker,
        colors.tealDark,
        colors.teal,
        colors.tealLight,
        colors.greyMedium,
        colors.redLighter,
        colors.redLight,
        colors.red,
        colors.redDark,
    ],
}

export default stateOfJSThemeColors
